import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSteamComponent } from './simple-icons-steam.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSteamComponent ],
    exports:      [ SimpleIconsSteamComponent ],
    bootstrap:    []
})
export class SimpleIconsSteamModule {}
